<script setup>
import { RouterView } from 'vue-router'
import { onMounted } from 'vue'
import ApiService from '@/services/api'
import CookieConsentBanner from '@/components/common/CookieConsentBanner.vue'

function initializeAuth() {
  // Get token from localStorage
  const token = localStorage.getItem('token') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('authToken')

  if (token) {
    // Set axios defaults
    if (window.axios) {
      window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    }

    // Set on your API service
    if (ApiService && ApiService.setAuthHeader) {
      ApiService.setAuthHeader(token)
    }

    console.log('Auth token initialized with token:', token.substring(0, 20) + '...')
  } else {
    console.log('No auth token found')
  }
}

onMounted(() => {
  initializeAuth()
})
</script>

<template>
  <RouterView />
  <CookieConsentBanner />
</template>

<style scoped>
/* Remove any global styling that might interfere */
</style>
